import { useState, useEffect } from "react";
import Button from "@/components/atoms/Button";
import Ticket from "@/types/Ticket";
import { router } from "@inertiajs/react";
import axios from "axios";

type Props = {
  ticket: Ticket;
  totalLoggedHours: string;
};

const EstimationTab = ({ ticket, totalLoggedHours }: Props) => {

  const convertHoursToHHMM = (estimation: number) => {
    const totalMinutes = Math.round(estimation * 60);
    const hh = Math.floor(totalMinutes / 60);
    const mm = totalMinutes % 60;

    const formattedHH = hh.toString().padStart(2, "0");
    const formattedMM = mm.toString().padStart(2, "0");

    return `${formattedHH}:${formattedMM}`;
  };

  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [estimationInput, setEstimationInput] = useState(convertHoursToHHMM(ticket.estimation || 0));
  const [estimation, setEstimation] = useState(ticket.estimation || 0);

  const convertHHMMToHours = (estionation: string) => {
    const [hours, minutes] = estionation.split(":").map(Number);
    const totalHours = hours + minutes / 60;

    return totalHours;
  };

  const handleEstimationChange = (estimation: string) => {
    setEstimationInput(estimation);
    const hour = convertHHMMToHours(estimation);
    setEstimation(hour);
  };

  const handleSubmit = () => {
    setIsSubmitting(true);

    const payload = {
      ticket: {
        estimate: parseFloat(estimation.toFixed(2))
      }
    };
   
    try {
      router.patch(
        `/tickets/${ticket.id}/set_estimation`,
        payload,
        {
          onSuccess: (page) => {
            setIsSubmitting(false);
          },
          onError: (errors) => {
            setIsSubmitting(false);
          },
          onFinish: () => {
            setIsSubmitting(false);
          },
        }
      );
    } catch (error) {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="p-10">
      <div>
        <div className="pb-6">
          <span className="text-md font-semibold">Estimation</span>
        </div>
        <div className="flex items-center justify-between border dark:border-border rounded-lg p-10 shadow-md">
          {/* Total Logged Hours */}
          <div className="flex items-center gap-10 space-y-2">
            <label htmlFor="logged-hours" className="font-medium">
              Total logged hours:
            </label>
            <div className="flex items-center space-x-2">
              <div className="flex flex-col">
                <div>
                  <span className="text-sm">Hours</span>
                </div>
                <div>
                  {totalLoggedHours}
                </div>
              </div>

            </div>
          </div>

          {/* Update Estimated Hours */}
          <div className="flex items-center gap-10 space-y-2">
            <label htmlFor="estimated-hours" className="font-medium">
              Update estimated hours:
            </label>
            <div className="flex items-center space-x-2">
              <div>
                <div>
                  <span className="text-sm">Hours</span>
                </div>
                <div>
                  <input
                    id="estimated-hours"
                    type="time"
                    value={estimationInput}
                    onChange={(event) => handleEstimationChange(event.target.value)}
                    placeholder="00:00"
                    pattern="[0-9]{2}:[0-9]{2}"
                    className="w-22 border border-border rounded-md px-2 py-1 text-sm focus:outline-none"
                  />
                </div>
              </div>
            </div>
          </div>

          <div>
            <Button disabled={isSubmitting} onClick={handleSubmit} className="inline-flex items-center gap-2 text-black">
              <span>Submit</span>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EstimationTab;
